@use "ui/styles/studio";

.wrapper {
  @include studio.studioContextMenuItem;
}
